import React from "react";
import aboutImg from "../../assets/img/images/h2_about_img.png";
import shape01 from "../../assets/img/images/about_shape01.png";
import shape02 from "../../assets/img/images/about_shape02.png";

const About = () => {
  return (
    <section id="about" className="about-area-two">
      <div className="container custom-container-four">
        <div className="row align-items-center">
          <div className="col-lg-12">
            <div
              className="about-content-two wow fadeInRight"
              data-wow-delay=".2s"
            >
              <div className="section-title section-title-two mb-15">
                <span className="sub-title" style={{display:'flex', justifyContent:'center'}}>Disclaimer</span>
           
              </div>
              <p>
              By acquiring $Kolia, you acknowledge that you are not 
              acquiring a security or investment contract, and you 
              consent to absolve the team of any liability and hold them 
              harmless for any potential losses or tax obligations. 
              While Koalia operates as a community-oriented Defi Ecosystem and 
              is not registered as a digital currency, it is imperative that you 
              ensure compliance with pertinent local laws and regulations prior
              to any transaction. Please be advised that cryptocurrencies do not 
              hold legal tender status and should not be regarded as investments.

              </p>
            </div>
          </div>

          {/* <div className="col-lg-6">
            <div
              className="about-img-two text-center wow fadeInLeft"
              data-wow-delay=".2s"
            >
              <img src={aboutImg} alt="" />
            </div>
          </div> */}
        </div>
      </div>

      {/* <div className="about-shape-wrap">
        <img src={shape01} alt="" className="shape-one" />
        <img src={shape02} alt="" className="shape-two rotateme" />
      </div> */}
    </section>
  );
};

export default About;
